// SEOSchemas Component - Adds global Schema.org structured data for SEO
// Includes Organization and SoftwareApplication schemas
import React from 'react';
import { Helmet } from 'react-helmet';

const SEOSchemas = () => {
  // Organization Schema - Tells Google about the company
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "SmartFacture AI",
    "alternateName": "SmartFacture",
    "url": "https://smartfacture-ai.com",
    "logo": "https://smartfacture-ai.com/logo.png",
    "description": "Solution de facturation électronique intelligente pour les entreprises françaises. Conforme à la réforme e-facturation 2026.",
    "foundingDate": "2024",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "FR",
      "addressRegion": "France"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": ["French", "English"],
      "email": "contact@smartfacture-ai.com"
    },
    "sameAs": [
      "https://www.linkedin.com/company/smartfacture-ai",
      "https://twitter.com/smartfacture"
    ],
    "knowsAbout": [
      "Facturation électronique",
      "E-facturation 2026",
      "Factur-X",
      "Logiciel de facturation",
      "Comptabilité freelance",
      "Auto-entrepreneur"
    ]
  };

  // SoftwareApplication Schema - Tells Google about the software product
  const softwareApplicationSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "SmartFacture AI",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": "EUR",
      "lowPrice": "14",
      "highPrice": "49",
      "offerCount": "3",
      "offers": [
        {
          "@type": "Offer",
          "name": "Starter",
          "price": "14",
          "priceCurrency": "EUR",
          "description": "30 factures/mois, Factur-X, Export PDF"
        },
        {
          "@type": "Offer",
          "name": "Pro",
          "price": "29",
          "priceCurrency": "EUR",
          "description": "Factures illimitées, Relances auto, Dashboard, Module URSSAF"
        },
        {
          "@type": "Offer",
          "name": "Expert",
          "price": "49",
          "priceCurrency": "EUR",
          "description": "Tout Pro + Rapprochement bancaire, Multi-utilisateurs, Support prioritaire"
        }
      ]
    },
    "description": "Logiciel de facturation électronique conforme à la réforme 2026. Générez des factures Factur-X, automatisez vos relances, gérez vos cotisations URSSAF et exportez votre comptabilité en 1 clic.",
    "url": "https://smartfacture-ai.com",
    "screenshot": "https://smartfacture-ai.com/screenshot-dashboard.png",
    "featureList": [
      "Factures Factur-X conformes 2026",
      "Relances automatiques des impayés",
      "Dashboard temps réel",
      "Module URSSAF intégré",
      "Relances automatiques",
      "Export comptable CSV",
      "Scanner IA de factures",
      "Export pour archivage légal"
    ],
    "applicationSubCategory": "Invoicing Software",
    "countriesSupported": "France",
    "softwareVersion": "2.0",
    "releaseNotes": "Conforme à la réforme e-facturation 2026"
  };

  // WebSite Schema for search box and site links
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "SmartFacture AI",
    "url": "https://smartfacture-ai.com",
    "description": "Solution de facturation électronique intelligente pour les entreprises françaises",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://smartfacture-ai.com/blog?search={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(softwareApplicationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  );
};

export default SEOSchemas;
